/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Save_Context_UnknownInputs */



/**
* | output |
* | --- |
* | "Enter the context window of every selected model the server does not report it for." |
*
* @param {Private_Models_Save_Context_UnknownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_save_context_unknown = /** @type {((inputs?: Private_Models_Save_Context_UnknownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Save_Context_UnknownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie das Kontextfenster jedes gewählten Modells an, für das der Server keines meldet.")
	return /** @type {LocalizedString} */ ("Enter the context window of every selected model the server does not report it for.")
});